import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import { Input, Button, Spinner } from "reactstrap";
import ReactPlayer from "react-player";
import {
  MediaController,
  MediaControlBar,
  MediaTimeRange,
  MediaTimeDisplay,
  MediaVolumeRange,
  MediaPlaybackRateButton,
  MediaPlayButton,
  MediaSeekBackwardButton,
  MediaSeekForwardButton,
  MediaMuteButton,
  MediaFullscreenButton,
} from "media-chrome/react";
import { Range, getTrackBackground, useThumbOverlap } from "react-range";

import widgetVideoTimeline from "../../../assets/images/icons-component/video.png";

import { random } from "../../../utils/actions";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const {
    config,
    nowPage,
    CodeValue,
    SetPending,
    showControl,
    setShowControl,
    onUpdate,
    actionEnd,
    setCanCopy,
  } = props;
  const rangeSliderRef = useRef<any>(null);
  const itemRef = useRef<any>(null);
  const inputRef = useRef<any>(null);
  const playerRef = useRef<any>(null);
  const [Source, setSource] = useState<any>("");
  const [playStatus, setPlayStatus] = useState<any>("0");
  const [YoutubeID, setYoutubeID] = useState<any>("");
  const [Duration, setDuration] = useState<any>("");
  const [SourceStr, setSourceStr] = useState<any>(config.data?.codeStr ?? "");
  const [Start, setStart] = useState<number>(0);
  const [End, setEnd] = useState<number>(0);
  const [onReady, setOnReady] = useState<any>("");
  const [count, setCount] = useState<any>(0);
  const rangeRef: any = React.useRef<Range>();
  const [isStream, setIsStream] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [randomStr, setRandomStr] = useState<string>(random(20));

  useEffect(() => {
    if (!nowPage) {
      setIsPlaying(false);
    }
  }, [config.selected, nowPage]);

  useEffect(() => {
    if (config.data && config.data?.codeStr) {
      setPlayStatus("1");
      setSource(validateAndCompleteUrl(config.data?.codeStr));
      setYoutubeID(extractYouTubeVideoId(config.data?.codeStr));
      if (
        (config.data?.start ||
          (config.data?.start === 0 &&
            typeof config.data?.start === "number")) &&
        config.data?.end
      ) {
        setStart(config.data?.start);
        setEnd(config.data?.end);
      }
      setShowControl(true);
      SetPending(false);
    }
  }, [config.data?.codeStr]);

  useEffect(() => {
    if (YoutubeID !== "") {
      durationGet(YoutubeID);
    }
  }, [YoutubeID]);

  useEffect(() => {
    if (playStatus === "2") {
      setTimeout(() => {
        const data = config.data;
        data.codeStr = SourceStr;
        data.isStream = isStream;
        onUpdate({ id: config.id, data: data });
        actionEnd(true);
        CodeValue(SourceStr);
        setPlayStatus("1");
        SetPending(false);
      }, 1000);
    }
  }, [playStatus, Source]);

  const checkValue = () => {
    if (Source === "" || YoutubeID === "") return;
    durationGet(YoutubeID);
    SetPending(true);
    setPlayStatus("2");
  };

  useEffect(() => {
    setSourceStr(
      `${Source}${Start ? `&start=${Math.floor(Start)}` : ""}${
        End ? `&end=${Math.floor(End)}` : ""
      }`,
    );
  }, [Source, Start, End]);

  const durationGet = (YoutubeID: string) => {
    const KEY = "AIzaSyAVZns-NAEL9NpU0WRDo3_1GWdhJ2pVfzk";
    fetch(
      `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails,liveStreamingDetails&key=${KEY}&id=${YoutubeID}`,
      {
        method: "GET",
      },
    )
      .then(response => response.json())
      .then(data => {
        if (
          "liveStreamingDetails" in data.items[0] &&
          !data.items[0].liveStreamingDetails.actualEndTime
        ) {
          setIsStream(true);
        } else {
          if (
            data &&
            data.items &&
            data.items.length > 0 &&
            data.items[0].contentDetails
          ) {
            if (End === 0) {
              setEnd(
                Number(
                  parseYouTubeDuration(data.items[0].contentDetails.duration),
                ),
              );
            }
            setDuration(
              parseYouTubeDuration(data.items[0].contentDetails.duration),
            );
            setIsStream(false);
            setOnReady(true);
          }
        }
        if (data && data.items && data.items.length > 0 && !username) {
          onUpdate({ id: config.id, listTitle: data.items[0].snippet.title });
          actionEnd(true);
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const validateAndCompleteUrl = (src: string) => {
    const youtubeIdPattern =
      /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/i;
    const timePattern = /[?&]t=(\d+)/i;
    const startPattern = /[?&]start=(\d+)/i;
    const endPattern = /[?&]end=(\d+)/i;
    let startInSeconds;
    let endInSeconds;

    const cleanUrl = src
      .replace(timePattern, "")
      .replace(startPattern, "")
      .replace(endPattern, "");

    const timeMatch = src.match(timePattern);
    if (timeMatch) {
      const timeInSeconds = timeMatch[1];
      setStart(Math.floor(Number(timeInSeconds)));
    } else {
      const startMatch = src.match(startPattern);
      if (startMatch) {
        startInSeconds = Math.floor(Number(startMatch[1]));
        setStart(startInSeconds);
      }
    }

    const endMatch = src.match(endPattern);
    if (endMatch) {
      endInSeconds = Math.floor(Number(endMatch[1]));
      setEnd(endInSeconds);
    }

    const idMatch = cleanUrl.match(youtubeIdPattern);
    if (idMatch) {
      return `https://www.youtube.com/watch?v=${idMatch[1]}`;
    } else {
      const videoId = cleanUrl.trim();
      return `https://www.youtube.com/watch?v=${videoId}`;
    }
  };

  function extractYouTubeVideoId(src: string) {
    const youtubeIdRegex =
      /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?/;
    const matches = src.match(youtubeIdRegex);
    if (matches && matches[1]) {
      return matches[1];
    } else {
      return src;
    }
  }

  function ToDDHHMMSS(seconds: number) {
    const hours = Math.floor((seconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  }

  function parseYouTubeDuration(duration: any) {
    const regex = /P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
    const match = duration.match(regex);
    if (!match) {
      return null;
    }
    const days = parseInt(match[1] || 0, 10);
    const hours = parseInt(match[2] || 0, 10);
    const minutes = parseInt(match[3] || 0, 10);
    const seconds = parseInt(match[4] || 0, 10);
    return days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds;
  }

  const MIN = 0;
  const handleChange = (newValues: any) => {
    const [start, end] = newValues;
    setStart(Math.floor(Number(start)));
    setEnd(Math.floor(Number(end)));
  };
  const handleFinalChange = (newValues: any) => {
    const [start, end] = newValues;
    setStart(Math.floor(Number(start)));
    setEnd(Math.floor(Number(end)));

    const newSource = `${validateAndCompleteUrl(Source)}`;
    setSourceStr(
      `${newSource}${Start ? `&start=${Math.floor(Start)}` : ""}${
        End ? `&end=${Math.floor(End)}` : ""
      }`,
    );
    const data = config.data;
    data.codeStr = newSource;
    data.isStream = isStream;
    data.start = start;
    data.end = end;
    onUpdate({ id: config.id, data: data });
    actionEnd(true);
    CodeValue(newSource);
  };

  const ThumbLabel = ({
    rangeRef,
    values,
    index,
  }: {
    rangeRef: Range | null;
    values: number[];
    index: number;
  }) => {
    const [labelValue, labelStyle] = useThumbOverlap(
      rangeRef,
      values,
      index,
      1,
      " - ",
      value => ToDDHHMMSS(Number(value)),
    );
    const stringValue = labelValue as string;
    return (
      <div
        data-label={index}
        className="slider-tooltip"
        style={{
          top: "-24px",
          ...(labelStyle as React.CSSProperties),
        }}
      >
        {stringValue}
      </div>
    );
  };

  useEffect(() => {}, [showControl, onReady, isStream]);

  useEffect(() => {}, [Start, End]);

  return (
    <React.Fragment>
      <div style={{ height: "100%", width: "100%", position: "absolute" }}>
        {playStatus === "1" && Source !== "" ? (
          <div
            className="videoTimeLine-player"
            style={{ height: "100%", width: "100%" }}
            ref={itemRef}
          >
            <MediaController
              style={{
                width: "100%",
              }}
            >
              <MediaPlayButton
                style={{ height: "100%", width: "100%", opacity: 0, zIndex: 5 }}
              />
              <MediaControlBar style={{ zIndex: 3 }}>
                {/* <MediaPlayButton /> */}
                {/* <MediaSeekBackwardButton seekOffset={10} />
        <MediaSeekForwardButton seekOffset={10} /> */}
                <MediaTimeRange />
                <MediaTimeDisplay showDuration />
                <MediaMuteButton />
                {/* <MediaVolumeRange /> */}
                {/* <MediaPlaybackRateButton /> */}
                {/* <MediaFullscreenButton /> */}
              </MediaControlBar>
              <div className="video-cover-full" style={{ zIndex: 2 }}></div>
              <ReactPlayer
                key={randomStr}
                ref={playerRef}
                src={Source}
                className="react-player"
                controls={false}
                playing={isPlaying}
                onPlay={() => {
                  setIsPlaying(true);
                }}
                onPause={() => {
                  setIsPlaying(false);
                }}
                config={{
                  youtube: {
                    start: Math.floor(Start),
                    end: Math.floor(End),
                    enablejsapi: 1,
                  },
                }}
                slot="media"
                style={{
                  width: "100%",
                  height: "300px",
                  "--controls": "none",
                }}
              />
            </MediaController>
            {showControl &&
            onReady &&
            !isStream &&
            !username &&
            !config.spotlight ? (
              <div
                className="componentCore d-flex justify-center items-center"
                style={{
                  height: "65px",
                  width: "100%",
                  padding: "6px 1rem 0",
                  paddingRight: 0,
                  cursor: "default",
                  marginTop: "-4px",
                }}
                data-interaction-target-type="false"
              >
                <div className="core-range">
                  <div
                    className="range-play"
                    onPointerDown={() => {
                      setRandomStr(random(20));
                      setIsPlaying(true);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      {/* <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> */}
                      <path d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z" />
                    </svg>
                  </div>
                  <div></div>
                  <div>
                    <Range
                      ref={rangeRef}
                      values={[Start, End]}
                      step={0.5}
                      min={MIN}
                      max={Duration}
                      onChange={handleChange}
                      onFinalChange={handleFinalChange}
                      renderTrack={({ props, children }) => (
                        <div
                          onMouseDown={props.onMouseDown}
                          onTouchStart={props.onTouchStart}
                          style={{
                            ...props.style,
                            height: "36px",
                            display: "flex",
                            width: "calc(100% - 36px)",
                          }}
                        >
                          <div
                            ref={props.ref}
                            style={{
                              height: "5px",
                              width: "100%",
                              borderRadius: "4px",
                              background: getTrackBackground({
                                values: [Start, End],
                                colors: [
                                  "#efefef",
                                  "var(--themebase)",
                                  "#efefef",
                                ],
                                min: MIN,
                                max: Duration,
                              }),
                              alignSelf: "center",
                            }}
                          >
                            {children}
                          </div>
                        </div>
                      )}
                      renderThumb={({ props, index, isDragged }) => (
                        <div
                          {...props}
                          className="slider-handle sliderBtn"
                          style={{
                            ...props.style,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            left: `${
                              (props["aria-valuenow"] / Duration) * 100
                            }%`,
                          }}
                        >
                          <ThumbLabel
                            rangeRef={rangeRef.current}
                            values={[Start, End]}
                            index={index}
                          />
                          <div
                            style={{
                              height: "100%",
                              width: "100%",
                              backgroundColor: isDragged
                                ? "var(--themeColor)"
                                : "var(--themebase)",
                              borderRadius: "50%",
                              overflow: "hidden",
                            }}
                          />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <>
            <div
              className="relative flex h-full flex-col items-center justify-center gap-6 p-6 bg-screen "
              style={{ cursor: "auto", borderRadius: "0.5rem" }}
            >
              <div className="widget-head text-area-head">
                <img src={widgetVideoTimeline} alt="" />
              </div>
              <textarea
                ref={inputRef}
                style={{ resize: "none" }}
                className="ts-text-area h-100 !text-lg"
                onChange={e => {
                  setSource(validateAndCompleteUrl(e.target.value));
                  setYoutubeID(extractYouTubeVideoId(e.target.value));
                }}
                placeholder="輸入 YouTube ID 或 網址..."
                defaultValue={Source}
                data-interaction-target-type="false"
                onFocus={() => {
                  setCanCopy(false);
                }}
                onBlur={() => {
                  setCanCopy(true);
                }}
              ></textarea>
              <Button
                color="primary"
                className={`ts-playBtn btn-load rounded-pill text-sm px-4 h-11 font-semibold ${
                  Source === "" ? "ts-disabled" : null
                }`}
                onClick={checkValue}
                data-interaction-target-type="false"
              >
                <div className="relative justify-center h-100 w-100">
                  {playStatus === "0" ? (
                    <span>建立</span>
                  ) : // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  //   {/* <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> */}
                  //   <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/>
                  // </svg>
                  playStatus === "2" ? (
                    <span className="ts-load d-flex justify-center items-center">
                      <Spinner size="sm" className="flex-shrink-0">
                        {" "}
                        Loading...{" "}
                      </Spinner>
                    </span>
                  ) : null}
                </div>
              </Button>
            </div>
            {username ? (
              <div
                className="absolute h-100 w-100 top-0 start-0"
                style={{ zIndex: 2 }}
              ></div>
            ) : null}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default memo(Index);
